import type { Action } from './actions'
import type { OrbOrderShortDTO } from 'shared/types'

export type State = {
    +orders: { [string]: OrbOrderShortDTO },
    +showWidget: boolean,
    +error: ?any,
    +isFocused?: boolean,
    +discarded?: boolean
}

const initialState: State = {
    orders: {},
    showWidget: false,
    discarded: false,
    error: null
}

export const reducer = (state: State = initialState, action: Action): State => {
    switch (action.type) {
        /** Add one order in the store, if id already exist -> overwrite */
        case 'FOLLOW_ORDER': {
            const { order } = action.data || {}
            return {
                ...state,
                orders: {
                    ...state.orders,
                    [order.id]: { ...order }
                },
                discarded: false
            }
        }
        /** Remove one order from the store */
        case 'UNFOLLOW_ORDER': {
            const { orderId } = action.data
            const { [orderId]: value, ...otherOrders } = state.orders
            return {
                ...state,
                orders: otherOrders
            }
        }
        case 'TOGGLE_WIDGET': {
            const { active } = action.data
            return {
                ...state,
                showWidget: active
            }
        }
        case 'DISCARD_WIDGET': {
            return {
                ...state,
                discarded: true
            }
        }
        /** Update the status of one order */
        case 'ORB_EVENT_UPDATE_ORDER': {
            /** Order from websocket */
            const { order } = action.data
            if (!state.orders || !state.orders[order.orderId]) {
                return state
            }
            return {
                ...state,
                orders: {
                    ...state.orders,
                    [order.orderId]: {
                        ...state.orders[order.orderId],
                        numberOrb: order.orbNb,
                        restaurant: order.restName,
                        savedStatus: order.status
                    }
                }
            }
        }
        /** Update last order */
        case 'UPDATE_LAST_ORDER': {
            const { order } = action.data || {}
            return {
                ...state,
                lastOrderId: order.id,
                orders: {
                    ...state.orders,
                    [order.id]: { ...state.orders[order.id], ...order }
                }
            }
        }
        /** replace all orders */
        case 'REPLACE_ORDERS': {
            const { orders } = action.data || {}
            return {
                ...state,
                /** Convert array to {key : object, ...} */
                orders: orders.reduce((acc, order) => {
                    acc[order.id] = order
                    return acc
                }, {})
            }
        }
        case 'ORB_FOCUS':
            return {
                ...state,
                isFocused: action.isFocused
            }
        case 'ORB_ERROR':
            return {
                ...state,
                error: action.error
            }
        default:
            return state
    }
}
